import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Resolve, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import 'rxjs/add/operator/map';

import { Customer } from './customer.model';
import { CustomerService } from './customer.service';

@Injectable()
export class CustomerResolver implements Resolve<Customer> {
  constructor(private customerService: CustomerService) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<Customer> {
    return this.customerService.getById(route.paramMap.get('customerId'), state.url.startsWith('/admin') ? 'adminSingle' : 'default');
  }
}



// WEBPACK FOOTER //
// ./src/app/core/data/customers/customer.resolver.ts